/*
 * IMPORTS
 */
import "react-date-range/dist/styles.css"; // Npm: React date range.
import "react-date-range/dist/theme/default.css"; // Npm: React date range.
import React from "react"; // Npm: react.js library.
import PropTypes from "prop-types"; // Npm: react.js library.
import { useHistory, useLocation } from "react-router-dom"; // Npm: React router dom.
import {
  Box,
  Button,
  Flex,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react"; // Npm: Chakra UI components.

/*
 * SIBLINGS
 */
import Links from "./Links";
import GMTClock from "./Clocks/index";

/*
 * IMPORTS
 */
const Index = ({
  secondary,
  message,
  brandText,
  timelineChildren,
  onOpen,
  logoText,
  routePaths,
  fixed,
  scrolled,
}) => {
  // Hook assignment.
  const _location = useLocation();
  const _history = useHistory();
  const _textColor = useColorModeValue("white.300", "white.300");

  // Const assignment.
  const _splitPath = React.useMemo(
    () => _location?.pathname?.split("/")?.filter((i) => "" !== i),
    [_location?.pathname],
  );
  const _locationFiltered = React.useMemo(() => {
    // Local variable.
    let currentPath;

    // Variable assignment.
    currentPath = "";

    // Return object.
    return _splitPath.reduce((__acc, __pot) => {
      // Variable assignment.
      currentPath += `/${__pot}`;

      // Object assignment.
      __acc[__pot] = currentPath;

      // Return object.
      return __acc;
    }, {});
  }, [_splitPath]);

  // Return component.
  return (
    <Box
      boxShadow="none"
      bg="linear-Gradient(73deg,#390EF6 0%, #9244F4 100%)"
      borderColor="transparent"
      filter="none"
      backdropFilter="blur(20px)"
      backgroundPosition="center"
      backgroundSize="cover"
      borderRadius="20px"
      h={"/" === _location.pathname ? "170px" : void 0}
      borderStyle="solid"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration=" 0.25s, 0.25s, 0.25s, 0s"
      transition-property="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear, linear, linear, linear"
      display={secondary ? "block" : "flex"}
      minH="75px"
      justifyContent={{ xl: "center" }}
      mt="0px"
      p="22px"
      pb="10px"
      right={{ base: "12px", md: "30px", lg: "30px", xl: "30px" }}
      px={{ sm: "15px", md: "10px" }}
      ps={{ xl: "12px" }}
      pt="8px"
      top={{ base: "12px", md: "16px", xl: "18px" }}
      w="100%"
    >
      <Flex w="100%" position="relative" flexDirection="column">
        <Flex
          pl={{ base: "0px", md: "12px" }}
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box mb={{ sm: "8px", md: "0px" }}>
            <Link
              color="#FFF"
              href="#"
              bg="inherit"
              borderRadius="inherit"
              fontWeight="300"
              fontSize="34px"
              alignItems="center"
              height="unset"
              _hover={{ color: _textColor }}
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "transparent",
              }}
              _focus={{ boxShadow: "none" }}
            >
              <Box display={{ base: "none", md: "block" }}>
                {brandText && <Text as="h4">{brandText}</Text>}
                {"/" !== _location.pathname && 1 !== _splitPath?.length && (
                  <Text
                    as="h4"
                    display="flex"
                    flexDirection="row"
                    gap="5px"
                    position="relative"
                    top="-5px"
                  >
                    <Text
                      as="p"
                      fontSize="16px"
                      color="gray.300"
                      fontWeight="500"
                    >
                      Navigation :
                    </Text>
                    {_splitPath.map((i, index) => {
                      const _nextPath = _locationFiltered[_splitPath[index]]
                      const _isRoutePath = routePaths?.has(_nextPath)

                      return (
                        <Button
                          bg="none"
                          px="0"
                          py="0"
                          height="unset"
                          color="white"
                          cursor={_isRoutePath ? "pointer" : "default"}
                          textTransform="capitalize"
                          _hover={{ bg: "none", opacity: _isRoutePath ? 0.7 : 1 }}
                          _active={{ bg: "none" }}
                          _focus={{ bg: "none" }}
                          onClick={() => {
                            if (_isRoutePath) _history.replace(_nextPath)
                          }}
                          key={`${i}-${index}`}
                        >
                          {i} {index === _splitPath?.length - 1 ? "" : ">"}
                        </Button>
                      )
                    })}
                  </Text>
                )}
              </Box>
            </Link>
          </Box>
          <Box display={{ base: "none", md: "block" }} ml="auto" mr="20px">
            <GMTClock />
          </Box>
          <Box w={{ base: "100%", md: "auto" }}>
            <Links
              onOpen={onOpen}
              logoText={logoText}
              fixed={fixed}
              scrolled={scrolled}
            />
          </Box>
        </Flex>
        {"/" === _location.pathname ? timelineChildren : void 0}
      </Flex>
      {secondary && message ? <Text color="white">{message}</Text> : null}
    </Box>
  );
};

/*
 * PROPTYPES
 */
Index.propTypes = {
  brandText: PropTypes.string,
  variant: PropTypes.string,
  secondary: PropTypes.bool,
  fixed: PropTypes.bool,
  onOpen: PropTypes.func,
  message: PropTypes.any,
  timelineChildren: PropTypes.object,
  logoText: PropTypes.string,
  routePaths: PropTypes.instanceOf(Set),
  scrolled: PropTypes.bool,
};

/*
 * EXPORT
 */
export default React.memo(Index);
